import React from 'react';

import Navigation from '../Navigation';
import NotificationList from '../NotificationList';


const PageWrapper = ({ children, title }) => (
    <div className="app">
        <header className="app-header navbar">
            <a className="navbar-brand"/>
            <h4 className="title-text">{title}</h4>
            <NotificationList />
        </header>
        <div className="app-body">
            <Navigation />
            <main className="main">
                <div className="container-fluid">
                    {children}
                </div>
            </main>
        </div>
        <footer className="app-footer" />
    </div>
);

export default PageWrapper;